import { I18n } from "i18n-js";
import en from "./locales/en.json";
import es from "./locales/es.json";

const i18n = new I18n();

// Load translations
i18n.store(en);
i18n.store(es);

// Set default locale
i18n.defaultLocale = "en";

// Get locale from HTML lang attribute or URL
function detectLocale() {
  // First try to get from URL path (e.g., /en/... or /es/...)
  const pathMatch = window.location.pathname.match(/^\/(en|es)\//);
  if (pathMatch) {
    return pathMatch[1];
  }
  
  // Fallback to HTML lang attribute
  const htmlLang = document.documentElement.lang;
  if (htmlLang && ["en", "es"].includes(htmlLang)) {
    return htmlLang;
  }
  
  // Default to English
  return "en";
}

// Set the current locale
i18n.locale = detectLocale();

// Update locale when Turbo navigates to a new page
document.addEventListener("turbo:load", () => {
  i18n.locale = detectLocale();
});

// Helper function for translations with fallback
export function t(key, options = {}) {
  return i18n.t(key, options);
}

// Export the i18n instance for direct access if needed
export default i18n;
